import type { AnnotatedStatement } from './types'
import { splitIntoBlocks } from './enSourceParser'

/**
 * Extract # comments from EN source and map them 1:1 to statements.
 * Port of Kotlin CommentExtractor.
 */
export function extractComments(source: string, statementCount: number): AnnotatedStatement[] {
    const blocks = splitIntoBlocks(source)
    const result: AnnotatedStatement[] = []

    for (let index = 0; index < blocks.length; index++) {
        if (index >= statementCount) break

        const block = blocks[index]
        const commentLines = block.lines.filter(l => l.text.trimStart().startsWith('#'))
        const statementLines = block.lines.filter(
            l => !l.text.trimStart().startsWith('#') && l.text.trim() !== ''
        )

        const comment = commentLines.length > 0
            ? commentLines.map(l => l.text.trimStart().replace(/^#\s*/, '')).join('\n')
            : null

        const statementStartLine = statementLines.length > 0
            ? statementLines[0].lineNumber
            : block.startLine
        const commentStartLine = commentLines.length > 0
            ? commentLines[0].lineNumber
            : null

        result.push({ index, comment, statementStartLine, commentStartLine })
    }

    return result
}
